import { excelRowPlanQuantity, sharedRowActuals, weekObservationDate } from "./week39-quantities";
import { formatCaseQuantity } from "./week39-view";
import type { PackagingViewRow } from "./week39-view";
import type { Week39PackagingLive, Week39PackagingSnapshot } from "./week39-types";
import { routePackagingProduction } from "./week39-production-lines";

export function Week39EntryAllocation({ snapshot, live, row }: {
  snapshot: Week39PackagingSnapshot; live: Week39PackagingLive | null; row: PackagingViewRow;
}) {
  if (row.plan.carryover || row.sharedRows < 2) return null;
  if (row.plan.productionLine) snapshot = routePackagingProduction(snapshot, live);
  const related = snapshot.lines.flatMap((line) => line.rows.map((plan) => ({ plan, lineName: line.name })))
    .filter(({ plan }) => plan.workOrderNo === row.plan.workOrderNo && plan.productCode === row.plan.productCode)
    .filter(({ plan }) => plan.productionLine === row.plan.productionLine)
    .sort((a, b) => (a.plan.excelSourceRow ?? a.plan.sourceRow) - (b.plan.excelSourceRow ?? b.plan.sourceRow));
  const observationDay = weekObservationDate(snapshot, live);
  return <section className="pack39-entry-allocation" aria-label="Ortak iş emrinin Excel satırlarına dağılımı">
    <h3>Bu satıra ayrılan miktarın hesabı</h3>
    <p>Üretim hattı Mikro belge adından belirlenir. Bu hattın üretimi aynı iş emrinin Excel satırlarına önce üretim gününün planına, ardından kaynak sırasıyla dağıtılır.</p>
    <div className="pack39-entry-allocation-head"><span>Excel satırı</span><span>Hafta planı</span><span>Ayrılan üretim</span></div>
    {related.map(({ plan, lineName }) => {
      const planned = excelRowPlanQuantity(plan);
      const actual = sharedRowActuals(snapshot, plan, observationDay, live).cumulative;
      return <div className={`pack39-entry-allocation-row${plan.sourceRow === row.plan.sourceRow ? " pack39-entry-allocation-selected" : ""}`} key={plan.sourceRow}>
        <span>{lineName} · {plan.excelSourceRow ?? plan.sourceRow}. satır{plan.sourceRow === row.plan.sourceRow ? " (seçili)" : ""}</span>
        <span>{planned.value === null ? "—" : formatCaseQuantity(planned.value)}</span>
        <strong>{actual.value === null ? "Doğrulanamadı" : formatCaseQuantity(actual.value)} KOLİ</strong>
      </div>;
    })}
  </section>;
}
